import { fetcher } from '@commenda/utils';
import { UpdateTransferPricingBenchmarkParams } from './types';

const updateTransferPricingBenchmark = async (
  id: string,
  body: UpdateTransferPricingBenchmarkParams
) => {
  const res = await fetcher(`transfer-pricing/benchmark/${id}`, {
    method: 'POST',
    body,
  });

  return res;
};

export default updateTransferPricingBenchmark;
